(function(){
    'use strict';
    angular.module('Services').service('AccountingCaseDetailsTable', AccountingCaseDetailsTable);
    AccountingCaseDetailsTable.$inject = [
        '$filter',
        '$uibModal',
        'TableLiteFactory'
    ];

    function AccountingCaseDetailsTable(
        $filter,
        $uibModal,
        TableLiteFactory
    ){
        return function(cases, shipmentId){
            const tableData = {
                config: {
                    noPagination: true,
                    notTopOptions: true,
                    noHeaders: false,
                    noItemsView: false,
                    noFooter: true,
                    colMinWidth: '135px'
                },
                headers: [
                    {
                        label: 'Description',
                        viewName: 'description'
                    },
                    {
                        label: 'Status',
                        viewName: 'status'
                    },
                    {
                        label: 'Resolved Date',
                        viewName: 'resolvedDate'
                    }
                ],
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: function(callback){
                    callback({content: cases})
                },
                callbackFormat: ['success'],
                postRequestCallback: data => {
                    buildTableData(data);
                }
            });

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data){
                tableActions.initializeTableData(data);
                if(!data) {
                    return null;
                }

                data.content.forEach(row=>{
                    row.status = row.status ? 'RESOLVED' : 'NOT RESOLVE'
                    row.resolvedDate = $filter('bbaDate')(row.resolvedDate);
                
                    if(!row.resolved){
                        row.class = 'bg-error';
                    }

                    tableData.data.push(row);
                });
            }
            this.tableData = tableData;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/AccountingCaseDetailsTable.js